module.exports = {
      id: "paypal-icon-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.09862bea.svg#paypal-icon",
      toString: function () {
        return this.url;
      }
    }